import { apiClient } from '../../../../api/axios';
import type { ApiResponse, PaginatedResponse } from '../common/types';
import type {
    ReviewerEvaluationProcessItem,
    GetReviewEvaluationsProcessPayload,
    SubmitFinalReviewerEvaluationDecisionPayload,
    ReviewerEvaluationFinalDecisionDetail,
    ReviewerEvaluationAssignmentDetail,
    CreateUpdateReviewerEvaluationPayload,
} from './types';

export const reviewerEvaluationReportService = {
    getReviewEvaluationsProcess: async (
        payload: GetReviewEvaluationsProcessPayload
    ): Promise<ApiResponse<PaginatedResponse<ReviewerEvaluationProcessItem>>> => {
        const response = await apiClient.post(
            '/ReviewerEvaluations/GetReviewEvaluationsProcess',
            {
                pageNumber: payload.pageNumber,
                pageSize: payload.pageSize,
                sortBy: payload.sortBy || '',
                sortDescending: payload.sortDescending ?? true,
                search: payload.search || '',
                completed: payload.completed,
                categoryId: payload.categoryId,
            }
        );
        return response.data;
    },

    submitFinalDecision: async (
        payload: SubmitFinalReviewerEvaluationDecisionPayload
    ): Promise<ApiResponse<boolean>> => {
        const response = await apiClient.post(
            '/ReviewerEvaluations/SubmitFinalReviewerEvaluationDecision',
            payload
        );
        return response.data;
    },

    getFinalDecisionByManuscriptReviewId: async (
        manuscriptReviewId: string
    ): Promise<ApiResponse<ReviewerEvaluationFinalDecisionDetail>> => {
        const response = await apiClient.get(
            `/ReviewerEvaluations/GetReviewerEvaluationFinalDecisionByManuscriptReviewId?manuscriptReviewId=${manuscriptReviewId}`
        );
        return response.data;
    },

    deletePanelMember: async (
        reviewEvaluationAssignmentId: string
    ): Promise<ApiResponse<boolean>> => {
        const response = await apiClient.post(
            `/ReviewerEvaluations/DeleteReviewEvaluationAssignment?reviewEvaluationAssignmentId=${reviewEvaluationAssignmentId}`
        );
        return response.data;
    },
};

export const reviewerEvaluationService = {
    /**
     * GET /ReviewerEvaluations/GetAssignedManuscriptById
     * Fetches the assignment + any existing draft evaluation for prefilling.
     */
    getAssignedManuscriptById: async (
        reviewerEvaluationAssignmentId: string
    ): Promise<ApiResponse<ReviewerEvaluationAssignmentDetail>> => {
        const response = await apiClient.get(
            `/ReviewerEvaluations/GetAssignedManuscriptById?reviewerEvaluationAssignment=${reviewerEvaluationAssignmentId}`
        );
        return response.data;
    },

    /**
     * POST /ReviewerEvaluations/CreateUpdateReviewerEvaluation
     * Creates or updates an evaluation. Set submit=false to save as draft,
     * submit=true to finalise.
     */
    createUpdateReviewerEvaluation: async (
        payload: CreateUpdateReviewerEvaluationPayload
    ): Promise<ApiResponse<string>> => {
        const response = await apiClient.post(
            '/ReviewerEvaluations/CreateUpdateReviewerEvaluation',
            payload
        );
        return response.data;
    },
};
